import api from './api'

/**
 * Programmes globaux / par défaut — SUPER_ADMIN (Back-Office).
 * Wizard aligné sur le flux company : brief → settings → sessions → resources → questions.
 */
export default {
  getAll(params = {}) {
    return api.get('/admin/programs', { params })
  },

  getOne(id) {
    return api.get(`/admin/programs/${id}`)
  },

  create(payload) {
    return api.post('/admin/programs', payload)
  },

  update(id, payload) {
    return api.put(`/admin/programs/${id}`, payload)
  },

  publish(id) {
    return api.post(`/admin/programs/${id}/publish`)
  },

  archive(id) {
    return api.post(`/admin/programs/${id}/archive`)
  },

  // Sessions
  getSessions(programId) {
    return api.get(`/admin/programs/${programId}/sessions`)
  },

  createSession(programId, payload) {
    return api.post(`/admin/programs/${programId}/sessions`, payload)
  },

  updateSession(programId, sessionId, payload) {
    return api.patch(`/admin/programs/${programId}/sessions/${sessionId}`, payload)
  },

  deleteSession(programId, sessionId) {
    return api.delete(`/admin/programs/${programId}/sessions/${sessionId}`)
  },

  createSessionFromTemplate(programId, payload) {
    return api.post(`/admin/programs/${programId}/sessions/from-template`, payload)
  },

  // Resources
  getResources(programId) {
    return api.get(`/admin/programs/${programId}/resources`)
  },

  addResources(programId, resourceIds) {
    return api.post(`/admin/programs/${programId}/resources`, {
      resources: resourceIds.map((resource_id) => ({ resource_id })),
    })
  },

  removeResource(programId, resourceId) {
    return api.delete(`/admin/programs/${programId}/resources/${resourceId}`)
  },

  getAvailableResources() {
    return api.get('/admin/programs/resources/available')
  },

  // Questions
  getQuestions(programId) {
    return api.get(`/admin/programs/${programId}/questions`)
  },

  createQuestion(programId, payload) {
    return api.post(`/admin/programs/${programId}/questions`, payload)
  },

  updateQuestion(programId, questionId, payload) {
    return api.patch(`/admin/programs/${programId}/questions/${questionId}`, payload)
  },

  deleteQuestion(programId, questionId) {
    return api.delete(`/admin/programs/${programId}/questions/${questionId}`)
  },

  // Localisation
  getTranslations(id) {
    return api.get(`/admin/programs/${id}/translations`)
  },

  localize(id, locales = null) {
    return api.post(`/admin/programs/${id}/localize`, locales ? { locales } : {})
  },

  saveTranslation(id, locale, payload) {
    return api.put(`/admin/programs/${id}/translations/${locale}`, payload)
  },
}
